import { useCallback } from "react";
import { cloneDeep } from "lodash";
import { useFormAPI } from "@/widgets/classic-form/form";
import { useFamilyFieldsWithExactnessDisabled } from "../shared/useFamilyFieldsWithExactnessDisabled";

export const useToggleFamilyExactness = () => {
    const { setFieldValue, getFieldValue } = useFormAPI();
    const config = useFamilyFieldsWithExactnessDisabled();

    return useCallback(
        (newValue: boolean) => {
            const familyValues = getFieldValue("family");
            const valuesCopy = cloneDeep(familyValues);
            Object.entries(valuesCopy).forEach(([relationKey, relation]) => {
                const givenNameDisabled = config.givenNameDisabled.has(relationKey);
                const surnameDisabled = config.surnameDisabled.has(relationKey);

                relation.instances.forEach((instance) => {
                    if (!givenNameDisabled) {
                        instance.givenNameExactness.isExact = newValue;
                    }
                    if (!surnameDisabled) {
                        instance.surnameExactness.isExact = newValue;
                    }
                });
            });
            setFieldValue("family", valuesCopy);
        },
        [getFieldValue, setFieldValue, config],
    );
};
